var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import clsx from 'clsx';
import React, { Fragment } from 'react';
import { UiButton, UiGrid, UiText, UiCard, UiFlex, UiIconMaterial } from '../..';
export function UiExampleButton() {
    return (React.createElement(UiGrid, { className: clsx('UiExampleButton') }, [-1, 0, 1, 2].map(function (size) { return (React.createElement(UiCard, { key: size, contentPadding: 2 },
        React.createElement(UiGrid, null,
            React.createElement(UiText, { weight: 2 },
                "Size:",
                size,
                " ",
                size === 0 && React.createElement(React.Fragment, null, "(Default)")),
            React.createElement(UiGrid, null, ['primary', 'secondary', 'success', 'error'].map(function (color) { return (React.createElement(UiCard, { contentPadding: 1, key: color },
                React.createElement(UiGrid, { spacing: 1 }, ['', 'isLoading', 'disabled'].map(function (prop) { return (React.createElement(UiFlex, { spacing: 1, key: prop }, ['text', 'filled', 'outlined'].map(function (variant) {
                    var _a, _b;
                    return (React.createElement(Fragment, { key: variant },
                        React.createElement(UiButton, __assign({ color: color, variant: variant, size: size }, (_a = {}, _a[prop] = true, _a)),
                            color,
                            " \u2022 ",
                            variant),
                        React.createElement(UiButton, __assign({ color: color, variant: variant, size: size, icon: React.createElement(UiIconMaterial, null, "add") }, (_b = {}, _b[prop] = true, _b)),
                            color,
                            " \u2022 ",
                            variant)));
                }))); })))); }))))); })));
}
